(function () {
  const HIDDEN_CLASS = 'is-variant-hidden';
  const COLOR_OPTION_NAMES = ['colour', 'color', 'kleur'];

  function getSelectedColor(root) {
    const scope = root || document;

    const colorFieldsets = scope.querySelectorAll('.product_template_new fieldset.single-option-radio');
    for (const fieldset of colorFieldsets) {
      const legend = fieldset.querySelector('.form__label, legend');
      const legendText = (legend?.textContent || '').trim().toLowerCase();
      const isColorFieldset = COLOR_OPTION_NAMES.some((name) => legendText.includes(name));

      if (!isColorFieldset) continue;

      const checkedInput = fieldset.querySelector('input:checked');
      if (checkedInput?.value) {
        return checkedInput.value.trim();
      }
    }

    const activeSwatch = scope.querySelector('.options-color-wrapper.active .option-item[data-value]');
    if (activeSwatch) {
      return activeSwatch.getAttribute('data-value')?.trim() || '';
    }

    const activeSwatchWrapper = scope.querySelector('.options-color-wrapper.active');
    if (activeSwatchWrapper) {
      const siblingInput = activeSwatchWrapper.previousElementSibling;
      if (siblingInput?.value) {
        return siblingInput.value.trim();
      }
    }

    const checkedInputs = scope.querySelectorAll(
      '.product_template_new .single-option-radio input:checked, .product_template_new variant-selects fieldset input:checked'
    );
    if (checkedInputs.length > 0) {
      return checkedInputs[0].value?.trim() || '';
    }

    return '';
  }

  function getSelectedVariantId(root) {
    const scope = root || document;
    const activeSwatch = scope.querySelector('.options-color-wrapper.active[data-var_id]');
    if (activeSwatch) {
      return activeSwatch.getAttribute('data-var_id') || '';
    }

    const checkedLabel = scope.querySelector('.single-option-radio input:checked + label[data-var_id]');
    if (checkedLabel) {
      return checkedLabel.getAttribute('data-var_id') || '';
    }

    return '';
  }

  function benefitMatchesVariant(matchValue, selectedColor, selectedVariantId) {
    const rules = matchValue
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

    if (!rules.length) return true;
    if (!selectedColor && !selectedVariantId) return false;

    return rules.some((rule) => {
      if (selectedColor && rule === selectedColor) return true;
      if (selectedVariantId && rule === selectedVariantId) return true;
      return false;
    });
  }

  function updateBenefitVisibility(root) {
    const scope = root || document.querySelector('.product_template_new');
    if (!scope) return;

    const selectedColor = getSelectedColor(scope);
    const selectedVariantId = getSelectedVariantId(scope);

    scope.querySelectorAll('.benefit-wrapper.buy-x-get-y').forEach((element) => {
      const matchValue = (element.dataset.variantMatch || '').trim();
      if (!matchValue) {
        element.classList.remove(HIDDEN_CLASS);
        return;
      }

      const visible = benefitMatchesVariant(matchValue, selectedColor, selectedVariantId);
      element.classList.toggle(HIDDEN_CLASS, !visible);

      const productWrapper = element.querySelector('.product-wrapper');
      if (!productWrapper) return;

      if (!visible) {
        productWrapper.classList.remove('active');
        return;
      }

      if (productWrapper.dataset.available !== 'false') {
        productWrapper.classList.add('active');
      }
    });
  }

  function initBenefitVariantVisibility() {
    const root = document.querySelector('.product_template_new');
    if (!root) return;
    if (!root.querySelector('.benefit-wrapper.buy-x-get-y[data-variant-match]')) return;

    updateBenefitVisibility(root);

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (
        target.closest('.options-color-wrapper') ||
        target.closest('.single-option-radio label') ||
        target.closest('.toggle-product-size-item')
      ) {
        window.requestAnimationFrame(() => updateBenefitVisibility(root));
      }
    });

    const variantContainer =
      root.querySelector('.product-single__add-to-cart') ||
      root.querySelector('.variant-selects-wrapper') ||
      root.querySelector('.product-form__item');

    if (variantContainer) {
      const observer = new MutationObserver(() => updateBenefitVisibility(root));
      observer.observe(variantContainer, { childList: true, subtree: true, attributes: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitVariantVisibility);
  } else {
    initBenefitVariantVisibility();
  }

  window.updateBenefitVisibility = updateBenefitVisibility;
})();
